export default __webpack_public_path__ + "static/media/goodInfo.fc293e96.png";